import { createContext, ReactElement, useContext, useState } from 'react';
import {
  EBetslipGlobalStateActions,
  TBetslipGlobalStateContext
} from 'newelements/_Betslip/types/global-state';
import { useEventbus } from 'newhooks/generic/useEventbus';

const initialState: TBetslipGlobalStateContext = {
  totalOdds: 0
};

export const BetslipGlobalStateContext = createContext(initialState);

export const BetslipGlobalStateProvider = ({
  children
}: PropsWithChildren): ReactElement => {
  const [globalState, setGlobalState] = useState(initialState);

  useEventbus({
    [EBetslipGlobalStateActions.SET_TOTAL_ODDS]: ({
      payload: totalOdds
    }: {
      payload: number;
    }) => {
      setGlobalState(prev => ({ ...prev, totalOdds }));
    }
  });

  return (
    <BetslipGlobalStateContext.Provider value={globalState}>
      {children}
    </BetslipGlobalStateContext.Provider>
  );
};

export const useBetslipGlobalStateContext = () =>
  useContext(BetslipGlobalStateContext);
